import { withInstall } from '@mts-fe/utils';
import { PCMode } from '@mts/utils/env';
import _PadHeader from './src/PadHeader.vue';
import _PcHeader from './src/PcHeader.vue';

export const MHeader = withInstall(PCMode ? _PcHeader : _PadHeader);
